import { Box, Button, Paper, Stack, Typography } from "@mui/material"
import { Link } from "react-router-dom"

const NotFoundError = (props) => {

	const handleReload = () => {
		window.location.reload()
	}
	
	return (
		<Box sx={{display: 'flex', width: '100%', height: props.height ? props.height : '88vh', alignItems: 'center', justifyContent: 'center'}}>
			<Paper elevation={4} sx={{paddingY: 6, paddingX: 4, borderRadius: 4}}>
				<Stack direction={'column'} alignItems={'center'} width={'100%'} spacing={1}>
					<img src={`${process.env.PUBLIC_URL}/images/system/notFoundError.png`} alt='imagem de erro' width={300} height={300}/>
					<Typography variant="h1" paddingLeft={1} fontWeight={800}>Oooops... Conteúdo não encontrado!</Typography>
					<Typography paddingLeft={1}>A página que você procura não foi encontrada. Volte para a <Link to="/">Página Inicial</Link> ou use nossa barra de pesquisa.</Typography>
				</Stack>
			</Paper>
		</Box>
	)
}

export default NotFoundError